import React from "react";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaBriefcase,
  FaHandshake,
} from "react-icons/fa";
import AdmissionsForm from "./AdmissionsForm";

const Contact = () => {
  const sectionStyle = {
    backgroundColor: "#f2faf5", // Matching Hero & Gallery Light Green
    padding: "80px 0",
  };

  return (
    <section id="contact" style={sectionStyle}>
      <Container>
        <Row className="mb-5 text-center">
          <Col>
            <h6 className="text-success fw-bold text-uppercase">
              Connect With Us
            </h6>
            <h2 className="fw-bold text-dark">Get in Touch</h2>
            <div
              className="mx-auto bg-success mt-2"
              style={{ width: "50px", height: "3px" }}
            ></div>
          </Col>
        </Row>

        <Row className="g-5">
          {/* Left Side: Contact Information */}
          <Col lg={5}>
            <div className="bg-white p-4 rounded shadow-sm h-100 border-top border-success border-4">
              <h4 className="fw-bold mb-4 text-dark">Contact Information</h4>

              <ListGroup variant="flush">
                <ListGroup.Item className="px-0 py-3 border-0 d-flex align-items-start bg-transparent">
                  <FaEnvelope className="text-success mt-1 me-3" size={20} />
                  <div>
                    <div className="fw-bold">General Enquiry</div>
                    <a
                      href="mailto:info@viriya.education"
                      className="text-muted text-decoration-none"
                    >
                      info@viriya.education
                    </a>
                  </div>
                </ListGroup.Item>

                <ListGroup.Item className="px-0 py-3 border-0 d-flex align-items-start bg-transparent">
                  <FaBriefcase className="text-success mt-1 me-3" size={20} />
                  <div>
                    <div className="fw-bold">Careers</div>
                    <a
                      href="mailto:hr@viriya.education"
                      className="text-muted text-decoration-none"
                    >
                      hr@viriya.education
                    </a>
                  </div>
                </ListGroup.Item>

                <ListGroup.Item className="px-0 py-3 border-0 d-flex align-items-start bg-transparent">
                  <FaHandshake className="text-success mt-1 me-3" size={20} />
                  <div>
                    <div className="fw-bold">Partnership</div>
                    <a
                      href="mailto:admin@viriya.education"
                      className="text-muted text-decoration-none"
                    >
                      admin@viriya.education
                    </a>
                  </div>
                </ListGroup.Item>

                <ListGroup.Item className="px-0 py-3 border-0 d-flex align-items-start bg-transparent">
                  <FaPhoneAlt className="text-success mt-1 me-3" size={20} />
                  <div>
                    <div className="fw-bold">Phone</div>
                    <div className="text-muted">09651344666, 09890542633</div>
                  </div>
                </ListGroup.Item>

                <ListGroup.Item className="px-0 py-3 border-0 d-flex align-items-start bg-transparent">
                  <FaMapMarkerAlt
                    className="text-success mt-1 me-3"
                    size={20}
                  />
                  <div>
                    <div className="fw-bold">Campus Location</div>
                    <div className="text-muted">
                      9A, Nat Mauk Yeik Thar St, Tarmwe Township, Yangon
                    </div>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </div>
          </Col>

          {/* Right Side: Admissions Form */}
          <Col lg={7} id="admission">
            <div className="bg-white p-4 p-md-5 rounded shadow-lg border-0">
              <h3 className="fw-bold mb-2">Apply for Admission</h3>
              <p className="text-muted mb-4">
                Complete the form below and our team will contact you shortly.
              </p>
              <AdmissionsForm />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
